import { Environment } from './types'

export const protocol: Record<Environment, string> = Object.freeze({
	development: 'http',
	staging: 'https',
	production: 'https',
})

export const blogDomainNames: Record<Environment, string> = Object.freeze({
	development: 'app.localhost',
	staging: 'hashnode.net',
	production: 'hashnode.dev',
})

export const communityDomainNames: Record<Environment, string> = Object.freeze({
	development: 'localhost:8080',
	staging: 'hashnode.xyz',
	production: 'hashnode.com',
})

// TODO: To be finalized
export const docsDomainNames: Record<Environment, string> = Object.freeze({
	development: 'docs.app.localhost',
	staging: 'docs.hashnode.space',
	production: 'hashnode.space',
})
